import { render, staticRenderFns } from "./SlideDeckResourceList.vue?vue&type=template&id=29a3c6fb"
import script from "./SlideDeckResourceList.vue?vue&type=script&lang=ts"
export * from "./SlideDeckResourceList.vue?vue&type=script&lang=ts"
import style0 from "./SlideDeckResourceList.vue?vue&type=style&index=0&id=29a3c6fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports